import { render, staticRenderFns } from "./Join.vue?vue&type=template&id=52267950&scoped=true"
import script from "./Join.vue?vue&type=script&lang=js"
export * from "./Join.vue?vue&type=script&lang=js"
import style0 from "./Join.vue?vue&type=style&index=0&id=52267950&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52267950",
  null
  
)

export default component.exports